import tagManager from 'react-gtm-module';
import reactGa from 'react-ga';
import { getFrameAttrs } from 'utils/embed';

export const initGtm = id => {
  tagManager.initialize({
    gtmId: id,
    dataLayer: {
      // set custom dimensions
      embed: getFrameAttrs(),
    },
  });
};

export const initGa = id => {
  reactGa.initialize(id, { debug: process.env.NODE_ENV === 'development' });
  // TODO set custom dimensions - need to use the dimension names configured in GA
  // const { isEmbedded, parentUrl, embeddedUrl } = getFrameAttrs();
  // reactGa.set({ dimension1: isEmbedded ? 'yes' : 'no' });
};

export const trackEventGtm = event => {
  // event: { category, action, label, value }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'mspEvent',
    ...event,
  });
};

export const trackEventGa = event => {
  // event: { category, action, label, value }
  reactGa.event({ ...event });
};
